import { request } from "../../utils/request";

/**
 * 获取指定类型的字典数据列表（精简版）
 * 接口：GET /system/dict-data/list-simple
 * 实际请求路径：/system/dict-data/list-simple（网关前缀由 request 统一添加）
 */
export const getDictDataListSimpleApi = (dictType: string) => {
  return request<Dict.DictListResponse>("/system/dict-data/list-simple", {
    method: "GET",
    params: { dictType },
  });
};

/** 新增目标语等场景：GET list-simple，dictType=target_language */
export const getTargetLanguageDictListSimpleApi = () =>
  getDictDataListSimpleApi("target_language");

